import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuFontButton} from '@Components/contextual-menu/components/contextual-menu-font-button';
import {BasePosterEditingFontOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-poster-editing-font-option';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';

interface TextSlideFontButtonProps {
  onClickFontButton(): void;
}

export function TextSlideFontButton({...props}: TextSlideFontButtonProps): ReactElement {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fontFamily = useGetKeyFromTextStylesOfSelectedTextSlideItem('fontFamily');

  if (!activeSlide) {
    throw new Error('unable to get the selected text slide');
  }

  if (fontFamily === undefined) {
    throw new Error('fontFamily attribute does not exist in the selected text slide');
  }

  const onClickHandler = (): void => {
    props.onClickFontButton();
  };

  return (
    <BasePosterEditingFontOption>
      <ContextualMenuFontButton id="text-slide-font-button" label={window.i18next.t('pmwjs_font')} selectedFontFamily={fontFamily} onClickFontButton={onClickHandler} />
    </BasePosterEditingFontOption>
  );
}
